import React, { useContext, useState } from 'react'
import { ThemeContext } from '../../../auth';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';
import axios from '../../../api/axios';

function ModalTambahPesertaMeeting({
    meetingid,
    showAddPeserta,
    setShowAddPeserta,
    listUser,
    rowSelected,
    retrieveUser,
    retrieveAkun,
    retrieveDetailAkun,
    retrieveDetailMeeting,
    retrievePeserta,
    tokenUser
}) {

    const { theme } = useContext(ThemeContext);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const handleClose = () => {
        setShowAddPeserta(false);
        setSelectedUser(null);
    };

    const userOptions = listUser.map(user => ({
        value: user.id,
        label: user?.first_name + ' ' + user?.last_name,
    }));

    const handleSelectUser = selectedOption => {
        setSelectedUser(selectedOption);
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? 'white' : '#222'
        },
        input: {
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            backgroundColor: theme === 'light' ? '#212529' : '#FFFFFF',
            color: theme === 'light' ? '#FFFFFF' : '#222'
        },
        button: {
            height: '50px',
        },
    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    const handleSubmitPeserta = async (event) => {

        event.preventDefault();
        setIsSubmitting(true);

        const data = {
            request: meetingid,
            user: selectedUser?.value,
        };

        setDisabled(true);

        try {
            const response = await axios.post(`/manage/peserta/`, data,
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        withCredentials: true,
                        Authorization: `Token ` + tokenUser,
                    },
                }
            );

            const dataNotification = {
                "user_id": selectedUser.value,
                "title": 'Pemberitahuan Meeting',
                "body": `${rowSelected.nama_meeting} \nTanggal: ${rowSelected?.waktu_mulai.split('T')[0]} \nWaktu: ${rowSelected?.waktu_mulai.split('T')[1].split(':').slice(0, 2).join(':')}`,
                "sound": "default",
                "data": {
                    "type": "reminder"
                }
            };

            const responseNotif = await axios.post(`/account/send-notification/`, dataNotification,
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        withCredentials: true,
                        Authorization: `Token ` + tokenUser,
                    },
                }
            );

            handleClose();
            Swal.fire({
                icon: 'success',
                title: 'Berhasil menambahkan peserta internal',
                showConfirmButton: true,
            })

            retrieveUser();
            retrieveAkun();
            retrieveDetailAkun();
            retrieveDetailMeeting();
            retrievePeserta();

            setIsSubmitting(false);
            setDisabled(false);
        } catch (err) {
            console.error(err);
            handleClose();
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan menambahkan peserta internal',
            });
            setIsSubmitting(false);
            setDisabled(false);
        }

    };


    return (
        <Modal
            show={showAddPeserta}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                    Tambah Peserta Internal
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmitPeserta}>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='user'>User*</Form.Label>
                        <Select
                            id='user'
                            options={userOptions}
                            required
                            value={selectedUser}
                            onChange={handleSelectUser}
                            styles={selectStyles}
                            placeholder='Select...'
                        />
                    </Form.Group>
                    <div className="d-grid gap-2 mt-4">
                        {isSubmitting ? (
                            <Button
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled
                            >
                                <Spinner
                                    animation="border"
                                    size='sm'
                                />
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled={disabled || !selectedUser}
                            >
                                Simpan
                            </Button>
                        )}
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalTambahPesertaMeeting
